// extracted by mini-css-extract-plugin
export default {"base-header":"Gb9Zg","baseHeader":"Gb9Zg","appear-from-above":"yQCNS","appearFromAbove":"yQCNS"};